
import { Capacitor } from '@capacitor/core';
import { SplashScreen, ShowOptions } from '@capacitor/splash-screen';

const Show = async (options?: ShowOptions) => {
	if(!Capacitor.isNativePlatform()) return;
	return await SplashScreen.show(options);
}

const Hide = async (options?: ShowOptions) => {
	if(!Capacitor.isNativePlatform()) return;
	return await SplashScreen.hide(options);
}

export const AppSplashScreen = {
	Show,
	Hide
}